// extracted by mini-css-extract-plugin
export default {"spinner__con":"styles_spinner__con__8gV9d","spinner":"styles_spinner__itCE9"};